(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        collection.filterGetContent(location.pathname + location.search);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

	  /* Collection Sorting */
      this.initCollectionSorting();

    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {

    },

fillterTagEvents: function() {
  // Tag filters are additive toggles: clicking a tag adds it (or removes it if already applied).
  $("body").delegate('.filter-tag:not([data-filter-widget]) a:not(".clear")', 'click', function(e) {
    e.preventDefault();
    collection.toggleTag($(this).prevAll("input[type='checkbox']").first().val());
  });

  // Small "x" on an applied tag removes just that tag.
  $("body").delegate('.filter-tag:not([data-filter-widget]) .filter-tag__remove', 'click', function(e) {
    e.preventDefault();
    collection.toggleTag($(this).siblings("input[type='checkbox']").first().val());
  });
},

    /* --------------------------------------------------------- */
    /* Server-rendered filters (collection.filters / Search & Discovery).
       Links and remove buttons carry Shopify's own URLs; multi-value URLs are
       handled with URLSearchParams because repeated keys (filter.p.tag=a&filter.p.tag=b)
       must all survive. */
    serverFilterEvents: function() {
      $("body").on('click', '[data-filter-widget] a[href]', function(e) {
        if (e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
        e.preventDefault();
        collection.navigate($(this).attr('href'));
      });

      $("body").on('click', '[data-filter-widget] .filter-tag__remove', function(e) {
        e.preventDefault();
        collection.navigate($(this).attr('data-filter-url'));
      });

      // Price range form: replace only this filter's params, keep everything else
      $("body").on('submit', '[data-filter-widget] form', function(e) {
        e.preventDefault();
        var params = new URLSearchParams(location.search);
        $(this).find('input[name]').each(function() {
          params.delete(this.name);
          if (this.value !== '') { params.set(this.name, this.value); }
        });
        params.delete('page');
        var query = params.toString();
        collection.navigate(location.pathname + (query ? '?' + query : ''));
      });
    },

    navigate: function(url) {
      if (!url || url === location.pathname + location.search) { return; }
      collection.fillterClick = true;
      History.pushState({}, document.title, url);
      collection.syncSortUI();
      collection.filterGetContent(url);
    },

    /* Swap each filter widget for the fresh server-rendered one (counts, applied state, URLs) */
    syncServerFilters: function(data) {
      var $incoming = $(data).find('[data-filter-widget]');
      var seen = {};
      $('[data-filter-widget]').each(function() {
        var key = $(this).attr('data-filter-widget');
        seen[key] = (seen[key] || 0) + 1;
        var $next = $incoming.filter(function() {
          return $(this).attr('data-filter-widget') === key;
        }).eq(seen[key] - 1);
        if ($next.length) { $(this).replaceWith($next); }
      });
    },

    /* Sort dropdown label/active item follow the URL (so Back/Forward stay correct) */
    syncSortUI: function() {
      var $links = $('.collection-sorting a');
      if (!$links.length) { return; }
      var sort = new URLSearchParams(location.search).get('sort_by');
      var $target = sort ? $links.filter(function() { return $(this).attr('href') === sort; }).first() : $links.first();
      if (!$target.length) { return; }
      $('.collection-sorting li.active').removeClass('active');
      $target.parent().addClass('active');
      $target.closest('.dropdown').find('.dropdown-label').text($.trim($target.text()));
    },

    /* Old shared links used ?constraint=a+b (handle-based, AND). Convert them once to the current
       filter.p.tag=Name params so the product grid and the highlighted chips agree. */
    migrateLegacyConstraint: function() {
      var params = new URLSearchParams(location.search);
      var legacy = params.get('constraint');
      var $names = $('[data-legacy-tag-names]').first();
      if (!legacy || !$names.length) { return false; }

      var byHandle = {};
      $.each(($names.attr('data-legacy-tag-names') || '').split('|'), function(i, name) {
        if (name) {
          byHandle[name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')] = name;
        }
      });

      params.delete('constraint');
      // URLSearchParams reads the "+" separator as a space
      $.each($.trim(legacy).split(/[\s+]+/), function(i, handle) {
        var name = byHandle[handle.toLowerCase()];
        if (name && $.inArray(name, params.getAll('filter.p.tag')) < 0) {
          params.append('filter.p.tag', name);
        }
      });
      var query = params.toString();
      location.replace(location.pathname + (query ? '?' + query : ''));
      return true;
    },

    /* Legacy (?constraint=) helpers - only used by old-style filter markup that isn't server-rendered.
       Tags currently applied, read from the URL (path tags + ?constraint=), lowercased, unique */
    activeTags: function() {
      var tags = [];
      var m = location.pathname.match(/\/collections\/[^\/]+\/([^\/]+)$/);
      if (m) {
        tags = decodeURIComponent(m[1]).split('+');
      }
      if (Shopify.queryParams && Shopify.queryParams.constraint) {
        tags = tags.concat(Shopify.queryParams.constraint.split('+'));
      }
      var seen = {};
      return $.grep($.map(tags, function(t) { return String(t).toLowerCase(); }), function(t) {
        if (!t || seen[t]) { return false; }
        seen[t] = true;
        return true;
      });
    },

    /* Collection URL without a trailing /tag segment (tags live in ?constraint= once toggled) */
    basePath: function() {
      return location.pathname.replace(/(\/collections\/[^\/]+)\/[^\/]+$/, '$1');
    },

    toggleTag: function(tagName) {
      if (!tagName) { return; }
      tagName = String(tagName).toLowerCase();
      var tags = collection.activeTags();
      var pos = $.inArray(tagName, tags);
      if (pos > -1) {
        tags.splice(pos, 1);
      } else {
        tags.push(tagName);
      }
      // Sorted so the same set of tags always produces the same URL
      if (tags.length) {
        Shopify.queryParams.constraint = tags.sort().join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
      collection.filterAjaxClick(collection.basePath());
      collection.syncTagFilters();
    },

    /* Make every tag control (checkbox, chip, aria state, remove button) reflect the URL */
    syncTagFilters: function() {
      var active = collection.activeTags();
      $(".filter-tag:not([data-filter-widget]) li").each(function() {
        var $li = $(this);
        var $input = $li.children("input[type='checkbox']");
        var $link = $li.children("a").first();
        if (!$input.length || !$link.length) { return; }
        var on = $.inArray(String($input.val()).toLowerCase(), active) > -1;
        var label = $link.attr("title") || $.trim($link.text());

        $input.prop("checked", on).attr({ "tabindex": "-1", "aria-hidden": "true" });
        $link.toggleClass("active", on).attr({ "role": "button", "aria-pressed": on ? "true" : "false" });

        var $remove = $li.children(".filter-tag__remove");
        if (!$remove.length) {
          $remove = $('<button type="button" class="filter-tag__remove" hidden><span aria-hidden="true">&times;</span></button>')
            .attr("aria-label", "Remove filter: " + label)
            .appendTo($li);
        }
        $remove.prop("hidden", !on);
      });
    },

    filterMapClearAll: function() {
      //clear all selection
        $("body").delegate( '.refined-widgets a.clear-all','click', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
          	$('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
          	
        });

         $("body").delegate( '.filter-block .clear', 'click', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active");
              });
              if (currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });

    },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
    
    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {    
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    }, 
    

    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
        collection.serverFilterEvents();
    },

    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        collection.syncTagFilters();

        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },

    filterMapData: function(data) {

        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");

        currentList.replaceWith(productList);

        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();
        collection.syncTagFilters();
        collection.syncServerFilters(data);
        collection.syncSortUI();
        var pageTitle = /<title>([^<]*)<\/title>/i.exec(data);
        if (pageTitle) { document.title = $('<textarea>').html(pageTitle[1]).text(); }
      	quickView();
        var ajaxCartConfig = {
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: null
        };
          jQuery(function($) {
          ajaxCart.init(ajaxCartConfig);
        });
      
        function loadmore() {
          $('.loadmore').children('a').on('click',function(e){
            $('.loadmore').addClass('d-none');
            $('.loading.tshopify-popup').addClass('active');
            var link = $('.loadmore').children('a').attr('href');
            if (link != '#' ) {
              $('.load-data').load(link+' .product-grid-view .row')

              setTimeout(function(){
                $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')})
                //           $('.loadmore').appendTo('.collection_prod .product-grid-view row')
                $('.loadmore').eq(0).remove();
                loadmore();
                quickView();
                var ajaxCartConfig = {
                  cartContainer: '.enj-minicart-ajax',
                  addToCartSelector: '.enj-add-to-cart-btn',
                  cartCountSelector: '.enj-cartcount',
                  cartCostSelector: '.enj-cartcost',
                  moneyFormat: null
                };
                  jQuery(function($) {
                  ajaxCart.init(ajaxCartConfig);
                });

                $('.loading.tshopify-popup').removeClass('active');
              },2000)
            } else {
              $('.loadmore').remove();
            }
            e.preventDefault();
          })
        }
        loadmore();
      
      
        jQuery('.engoj_select_color a').each(function(){
          jQuery(this).on("click",function(){
            var engoImage = jQuery(this).data('engojvariant-img');
            jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
            return false;
          });
        });

    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {

      // Cancel a still-running request so a slow, older response can't overwrite a newer one
      if (collection.filterXhr) {
        collection.filterXhr.abort();
      }

      collection.filterXhr = $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },

        success: function(data) {

          collection.filterMapData(data);

          collection.filterMapClear();
          hidePopup('.loading');
          hidePopup('.filter-to-left , .js-bg');
		  
        },

        error: function(xhr, text) {
          if (text === 'abort') { return; }
          hidePopup('.loading');
          hidePopup('.filter-to-left, .js-bg');
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }

      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        if (collection.migrateLegacyConstraint()) { return; }
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
        collection.syncTagFilters();

      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      // A fresh load with ?sort_by= in the URL should show that sort in the dropdown
      collection.syncSortUI();

      $(".collection-sorting a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var params = new URLSearchParams(location.search);
          params.set("sort_by", $(this).attr("href"));
          params.delete("page");
          collection.navigate(location.pathname + "?" + params.toString());
        }
        $(this).closest('.dropdown-content').removeClass('active');
      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);